import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as yup from "yup";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { transferableState } from "./utilities";

const requestSchema = yup.object({
  path: yup.string().required(),
  data: yup.mixed().required(),
});

export const useSaveFormStateMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      const req = requestSchema.validateSync(data, { strict: true });
      return http.post(HTTP_ENDPOINTS.formStates.update(), {
        state: transferableState.encode(req),
      });
    },
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.formStates.all],
      });
      options.onSuccess?.(...args);
    },
  });
};
